import pokedex from '../assets/images/pokedex.png';

const Pokedex = () => {
  return (
    <div>
      <a href='#projects'><strong>Pokedex</strong> API</a>
      <img src={pokedex} alt='baccarat' className='' />
    </div>
  )
}

export default Pokedex;